export const removeRowsByCondition = (worksheet, rule) => {
  const columnIndex = worksheet.getColumn(rule.inputColumn).number;
  const rowsToRemove = [];
  worksheet.eachRow((row, rowIndex) => {
    const cellValue = row.getCell(columnIndex).value;

    if (rule?.skipConditionType === "empty") {
      if (cellValue === null || cellValue === undefined || cellValue === "") {
        rowsToRemove.push(rowIndex);
      }
    } else if (
      (!rule?.skipConditionType || rule?.skipConditionType === "value") &&
      cellValue === rule?.skipCondition
    ) {
      rowsToRemove.push(rowIndex);
    }
  });
  for (let i = rowsToRemove.length - 1; i >= 0; i--) {
    worksheet.spliceRows(rowsToRemove[i], 1);
  }

  return rowsToRemove;
};
